import * as d3 from "d3";
import * as moment from "moment";

export interface DataPoint {
    label: string;
    value?: number;
    values?: number[];
}

export interface DataPointWithID extends DataPoint {
    id: string | number;
}

export function applyIfExists(f: (...x) => any, ...args) {
    if (f) {
        return f.apply(null, args);
    }
}

export const GRANULARITY_YEARLY_TEXT_KEY = "granularity_yearly";
export const GRANULARITY_QUARTERLY_TEXT_KEY = "granularity_quarterly";
export const GRANULARITY_MONTHLY_TEXT_KEY = "granularity_monthly";
export const GRANULARITY_WEEKLY_TEXT_KEY = "granularity_weekly";
export const GRANULARITY_DAILY_TEXT_KEY = "granularity_daily";
export const GRANULARITY_HOURLY_TEXT_KEY = "granularity_hourly";
export const PRODUCT_CHART_STYLE_LABEL_TEXT_KEY = "product_chart_style_label";

export function getGranularities(translations: any) {
    return [
        {
            key: 0,
            name: translations[GRANULARITY_YEARLY_TEXT_KEY],
            available: false,
            rangeLimits: {
                min: moment.duration(1, "year"),
                max: moment.duration(10, "year"),
            },
            timeInterval: d3.timeYear.every(1),
        },
        {
            key: 1,
            name: translations[GRANULARITY_QUARTERLY_TEXT_KEY],
            available: false,
            rangeLimits: {
                min: moment.duration(120, "day"),
                max: moment.duration(3, "year"),
            },
            timeInterval: d3.timeMonth.every(1),
        },
        {
            key: 2,
            name: translations[GRANULARITY_MONTHLY_TEXT_KEY],
            available: false,
            rangeLimits: {
                min: moment.duration(31, "day"),
                max: moment.duration(365 * 1.5, "day"),
            },
            timeInterval: d3.timeMonth.every(1),
        },
        {
            key: 3,
            name: translations[GRANULARITY_WEEKLY_TEXT_KEY],
            available: false,
            rangeLimits: {
                min: moment.duration(2, "week"),
                max: moment.duration(365 * 1.5, "day"),
            },
            timeInterval: d3.timeMonday.every(1),
        },
        {
            key: 4,
            name: translations[GRANULARITY_DAILY_TEXT_KEY],
            available: true,
            rangeLimits: {
                min: moment.duration(1, "day"),
                max: moment.duration(45, "day"),
            },
            timeInterval: d3.timeDay.every(1),
        },
        {
            key: 5,
            name: translations[GRANULARITY_HOURLY_TEXT_KEY],
            available: false,
            rangeLimits: {
                min: moment.duration(1, "hour"),
                max: moment.duration(3, "day"),
            },
            timeInterval: d3.timeHour.every(1),
        },
    ];
}

export function getTools(translations: any, onPanSelected, onInfoSelected, onExport) {
    return [
        {
            key: 3,
            name: translations.tool_pan_and_zoom,
            icon: "images/buttons/icon-selectCursor.png",
            onClick: onPanSelected,
        },
        {
            key: 0,
            name: translations.tool_info_cursor,
            icon: "images/buttons/icon-infoCursor.png",
            onClick: onInfoSelected,
        },
        {
            key: "export",
            name: translations.tool_export,
            icon: "images/buttons/icon-excelLogo.png",
            onClick: onExport,
        },
    ];
}

export function lerpColor(a, b, amount) {
    const ah = parseInt(a.replace(/#/g, ""), 16);
    const ar = ah >> 16;
    const ag = ah >> 8 & 0xff;
    const ab = ah & 0xff;
    const bh = parseInt(b.replace(/#/g, ""), 16);
    const br = bh >> 16;
    const bg = bh >> 8 & 0xff;
    const bb = bh & 0xff;
    const rr = ar + amount * (br - ar);
    const rg = ag + amount * (bg - ag);
    const rb = ab + amount * (bb - ab);

    return "#" + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
}

export const emptyFunction = () => undefined;
